import React from "react";
import { ArrowRight } from "lucide-react";

export default function BulkCTA() {
  return (
    <section className="bg-[color:var(--dms-peach)]/95 py-20">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <p className="text-[color:var(--dms-navy)] tracking-[0.28em] uppercase text-xs font-semibold">Bulk orders</p>
        <h2 className="font-serif text-3xl md:text-5xl text-[color:var(--dms-navy)] mt-4 leading-tight">
          Need 12, 30, 50+ shirts?<br /> Get a custom quote!
        </h2>
        <p className="mt-6 text-[color:var(--dms-navy)]/80 max-w-2xl mx-auto">
          Ordering shirts for your church, birthday, business, family, team, or special event? Tell us what you need and we’ll calculate a custom price for you.
        </p>
        <div className="mt-8">
          <a href="#group" className="btn-navy">Request my custom quote <ArrowRight className="w-4 h-4" /></a>
        </div>
      </div>
    </section>
  );
}
